import { u as l } from "./unleadingSlashIt-D4xkFtcJ.mjs";
const s = (a) => `/${l(a)}`, n = s;
export {
  n as l
};
//# sourceMappingURL=leadingSlashIt-CWANEco5.mjs.map
